<template>
  <div>
    <button class="file">
      选择文件
      <input type="file" @change="handlerUpload($event)" :accept="accept" />
    </button>

    {{filename}}
  </div>

</template>

<script>
  import {
    updateLoad
  } from "@/services/common";

  export default {
    name: "FFileSelect",
    props: {
      accept: {
        type: String,
        default: ""
      },
      autoUpload: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value(value) {
        this.filename = "";
      }
    },
    data() {
      return {
        filename: ""
      }
    },
    mounted() {

    },
    destroyed() {
      // debugger
    },
    methods: {
      async handlerUpload(event) {
        this.filename = event.target.files[0].name;
        if (this.autoUpload) {
          const res = await updateLoad(event.target.files[0]);
          if (res) {
            this.$emit("select", event)
            this.$emit("input", res.data);
          } else {
            this.$message({
              type: 'warning',
              message: "上传附件失败"
            });
            this.filename = "";
            this.$emit("select", "")
            this.$emit("input", "");
          }
        } else {
          this.$emit("select", event)
          this.$emit("input", event.target.files[0]);
        }

      },
    }
  }
</script>

<style scoped>
  .file {
    position: relative;
    background: rgba(24, 144, 255, 0.4);
    border: 1px solid rgba(24, 144, 255, 0.4);
    border-radius: 4px;
    padding: 5px 12px;
    overflow: hidden;
    color: #1890FF;
    text-decoration: none;
    text-indent: 0;
    line-height: 20px;
  }

  .file input {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
  }

  .file:hover {
    background: #aadffd;
    border-color: #78c3f3;
    color: #004974;
    text-decoration: none;
  }
</style>
